export default __webpack_public_path__ + "static/design_team-b827dbeaf8db10019234e173502b14e7.jpg";